export const getRichMediaState = (state, ownProps) => state.getIn(['app', 'richMedia']);
export const getRichMediaContentState = (id, richMediaState) => richMediaState.getIn([id, 'contentState']);
